import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { getFormsDetails, IFormsDetails } from 'API/formsDetails';
import { useEffect, useState } from 'react';
import { format } from 'date-fns';

export const FormsDetails = () => {
  const dateFormat = 'HH:mm dd.MM.yy';
  const [forms, setForms] = useState<IFormsDetails[]>([]);

  const getAndSetForms = async () => {
    const formsDetailsData = await getFormsDetails();
    if (formsDetailsData) {
      setForms(formsDetailsData);
    }
  };

  useEffect(() => {
    getAndSetForms();
  }, []);

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>מספר טופס</TableCell>
              <TableCell>שם פרטי</TableCell>
              <TableCell>שם משפחה</TableCell>
              <TableCell>ת"ז</TableCell>
              <TableCell>תאריך פתיחת טופס</TableCell>
              <TableCell>מס' סטטוס</TableCell>
              <TableCell>שם סטטוס</TableCell>
              <TableCell>תאריך סטטוס</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {forms.map((form, i) => (
              <TableRow key={i}>
                <TableCell>{form.formId}</TableCell>
                <TableCell>{form.firstName}</TableCell>
                <TableCell>{form.lastName}</TableCell>
                <TableCell>{form.israeliId}</TableCell>
                <TableCell>
                  {format(new Date(form.createdAt), dateFormat)}
                </TableCell>
                <TableCell>{form.statusTypeId}</TableCell>
                <TableCell>{form.statusName}</TableCell>
                <TableCell>
                  {form.statusDate
                    ? format(new Date(form.statusDate), dateFormat)
                    : ''}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
